import React from 'react';
import { RouteComponentProps } from 'react-router';
import PageContainer from '../../PageContainer';
import { MeetingMinutes } from './MeetingMinutes';

export const MeetingMinutesPage = ({ history }: RouteComponentProps) => {
  return (
    <PageContainer history={history}>
      <MeetingMinutes />
    </PageContainer>
  );
};
